export default "__VITE_ASSET__CIDZtJ9P__"